import React from "react";
import "../css/arrival.css";
import { checkedData } from "../rawData/MenuData";
import { RiArrowDownSFill } from "react-icons/ri";
const SizeList = () => {
  return (
    <>
      <div className="sideBox">
        <ul className="border-top ">
          <button
            className="brandbtn"
            type="button"
            data-toggle="collapse"
            data-target="#size"
          >
            Size <RiArrowDownSFill />
          </button>
          <div id="size" class="collapse">
            <form>
              <div>
                <ul>
                  {checkedData.map((value) => (
                    <button className="btn pr-2 pl-2 border m-2 outlet sizebtn">
                      10
                    </button>
                  ))}
                </ul>
              </div>
            </form>
          </div>
        </ul>
      </div>
    </>
  );
};

export default SizeList;
